export default __webpack_public_path__ + "static/media/Armbands of Illuminant Conviction.4ead36c5.jpg";